import { put } from 'redux-saga/effects'
import { tooggleReload } from '../reducers/reloadSlice'

function* reloadSaga() {
  // @ts-ignore
  yield put(tooggleReload())
}

export default reloadSaga
